import { combineEpics } from "redux-observable";
import { epicAutoSetAnimation } from "./epics/epicAutoSetAnimation";
import { epicCacheAnimations } from "./epics/epicCacheAnimations";
import { epicCollectProductAnimation } from "./epics/epicCollectProductAnimation";
import { epicContractFulfillAnimation } from "./epics/epicContractFulfillAnimation";
import { epicQuestFinishAnimation } from "./epics/epicQuestFinishAnimation";
import { epicScreenSpaceAnimation } from "./epics/epicScreenSpaceAnimation";
export var epicAnimations = combineEpics(epicCacheAnimations, epicScreenSpaceAnimation, epicQuestFinishAnimation, epicContractFulfillAnimation, epicCollectProductAnimation, epicAutoSetAnimation);



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epicAnimations.ts
// module id = 1761
// module chunks = 3